"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const therapies = ["Lava Shell Relaxation", "Full Body Massage £65", "Deep Tissue Recovery", "Signature Glow Facial", "30 Min Back & Shoulders £35", "Hot Stone Serenity"];
const carouselImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/lava_shell_massage.png",
  alt: "Warm lava shells placed on back for deep relaxation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/full_body_ritual.png",
  alt: "Soothing full body massage in a candlelit room"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/facial_rejuvenation.png",
  alt: "Gentle facial massage with organic oils"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/massage_room_zen.png",
  alt: "Serene massage treatment room with soft lighting"
}];
export default function TherapiesOverview() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll();
  return <section data-section-id="17740" id="massage-services" className="bg-background text-foreground py-20 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-64 w-96 h-96 bg-accent/20 rounded-lg blur-3xl opacity-40" />
        <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-primary/10 rounded-lg blur-3xl opacity-30" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={carouselRef} className={`transition-all duration-1000 ease-out ${isCarouselVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative">
              {}
              <div className="absolute -inset-4 bg-primary/5 rounded-2xl blur-md -z-10" />
              
              <Carousel className="w-full rounded-xl overflow-hidden shadow-xl border border-border/30">
                <CarouselContent>
                  {carouselImages.map((image, i) => <CarouselItem key={i} data-index={i}>
                      <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
                        <img src={image.src} alt={image.alt} className="object-cover w-full h-full hover:scale-105 transition-transform duration-1000 ease-in-out" />
                      </div>
                    </CarouselItem>)}
                </CarouselContent>
                <div className="hidden md:block">
                  <CarouselPrevious className="left-4 bg-white/60 hover:bg-white text-foreground border-none shadow-md backdrop-blur-sm" />
                  <CarouselNext className="right-4 bg-white/60 hover:bg-white text-foreground border-none shadow-md backdrop-blur-sm" />
                </div>
              </Carousel>
              
              {}
              <div className="absolute -bottom-6 -right-6 bg-white/80 backdrop-blur-md p-6 rounded-lg shadow-lg border border-border/20 hidden md:block max-w-xs">
                <p className="text-[10px] font-sans font-semibold text-primary uppercase tracking-[0.2em] mb-2">
                  The Experience
                </p>
                <p className="text-sm text-foreground font-serif italic leading-relaxed">
                  "A poetic sequence of movements designed to restore your inner sanctuary."
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="space-y-8">
              <div>
                <h2 className="text-[42px] md:text-5xl font-serif font-light text-foreground mb-6 leading-[1.1]">
                  The Art of <span className="text-primary italic">Deep Relaxation</span>
                </h2>
                <p className="text-lg text-muted-foreground font-sans leading-relaxed">
                  Indulge in a curated collection of massage rituals that blend ancient wisdom with modern comfort. Our therapists utilize intuitive touch and premium botanical oils to dissolve tension and harmonize the spirit.
                </p>
              </div>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-4">
                {therapies.map((therapy, i) => <li key={i} data-index={i} className="flex items-center gap-3 group border-b border-border/30 pb-2">
                    <span className="flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-lg bg-accent text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500">
                      <Check className="w-3 h-3" />
                    </span>
                    <span className="text-foreground/70 font-sans text-sm tracking-wide group-hover:text-foreground transition-colors duration-300">
                      {therapy}
                    </span>
                    {i === 0 && <span className="text-foreground font-medium text-sm">
                        £65
                      </span>}
                    {i === 2 && <span className="text-foreground font-medium text-sm">
                        £65
                      </span>}
                    {i === 3 && <span className="text-foreground font-medium text-sm">
                        £55
                      </span>}
                    {i === 5 && <span className="text-foreground font-medium text-sm">
                        £65
                      </span>}
                  </li>)}
              </ul>

              <div className="pt-4">
                <Link to="https://content-man.10web.cloud/the-clinic/">
                  <Button size="lg" className="rounded-lg px-10 bg-transparent border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-500 font-sans tracking-widest uppercase text-xs">
                    Book Treatment
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}